import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Navbar, Footer } from '../../components/PublicLayout';

export const Route = createFileRoute('/(public)')({
  component: PublicLayout,
});

function PublicLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}
